import { urlFormat } from '@datapad/utilities';
import { baseImageUrl } from './Constants.js';
import { getMaxImageDimensionInPixels, loadAndRenderImage } from './ImageUtilities.js';
const factionPlaceholderImagePath = `${baseImageUrl}/factions/missing-faction.png`;
export var FactionImageSize;
(function (FactionImageSize) {
    FactionImageSize["Small"] = "small";
    FactionImageSize["Large"] = "large";
})(FactionImageSize || (FactionImageSize = {}));
export function renderFirstFactionEmblem(factionNames, options) {
    const cleanedNames = factionNames.map((factionName) => urlFormat(factionName));
    const factionImageUrls = [];
    cleanedNames.forEach((cleanedName) => {
        const urls = getSizedFactionUrls(`${baseImageUrl}/factions/${cleanedName}`, options);
        factionImageUrls.push(...urls);
    });
    const urls = [...factionImageUrls, factionPlaceholderImagePath];
    const key = cleanedNames.length > 0
        ? cleanedNames.reduce((aggregate, current) => `${aggregate}-${current}`)
        : 'no-factions';
    return loadAndRenderImage(urls, options, `${key}-image`);
}
export function renderFactionEmblem(factionName, options) {
    const cleanedName = urlFormat(factionName);
    const factionImageUrls = getSizedFactionUrls(`${baseImageUrl}/factions/${cleanedName}`, options);
    const urls = [...factionImageUrls, factionPlaceholderImagePath];
    return loadAndRenderImage(urls, options, `${cleanedName}-image`);
}
export function renderFactionPlaceholderImage(options) {
    return loadAndRenderImage([factionPlaceholderImagePath], options, 'missing-faction-image');
}
function getFactionImageSizes(options) {
    const maxImageDimensionInPixels = getMaxImageDimensionInPixels(options.maxHeightInPixels, options.maxWidthInPixels);
    if (maxImageDimensionInPixels === undefined || maxImageDimensionInPixels > 250) {
        return [FactionImageSize.Large, FactionImageSize.Small];
    }
    return [FactionImageSize.Small, FactionImageSize.Large];
}
export function getSizedFactionUrls(urlBase, options) {
    const recommendedSizes = getFactionImageSizes(options);
    return recommendedSizes.map((size) => `${urlBase}-${size}.png`);
}
//# sourceMappingURL=FactionImageUtilities.js.map